import axios from 'axios';
import {
  HOME_FETCH_STATISTICS_BEGIN,
  HOME_FETCH_STATISTICS_SUCCESS,
  HOME_FETCH_STATISTICS_FAILURE,
  HOME_FETCH_STATISTICS_DISMISS_ERROR,
} from './constants';
import {fetchLicenses, fetchLoginStatistics} from "./actions";

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchStatistics(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_FETCH_STATISTICS_BEGIN,
    });
    const { user_id: id } = getState().home.user.authenticationModel;
    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get('https://smartometer-api.appucations.de/exercisestatistics?id=' + id);
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_FETCH_STATISTICS_SUCCESS,
            data: res,
          });
          dispatch(fetchLoginStatistics(args));
          dispatch(fetchLicenses(args));
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_FETCH_STATISTICS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchStatisticsError() {
  return {
    type: HOME_FETCH_STATISTICS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_STATISTICS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchStatisticsPending: true,
        fetchStatisticsError: null,
      };

    case HOME_FETCH_STATISTICS_SUCCESS:
      // The request is success
      const products = [];
      return {
        ...state,
        fetchStatisticsPending: false,
        fetchStatisticsError: null,
        statistics: {
          ...state.statistics,
          exerciseStatistics: action.data.data.exerciseStatistics,
        },
        products: action.data.data.exerciseStatistics.filter((obj, pos, arr) => {
          return arr.map(mapObj => mapObj['productName']).indexOf(obj['productName']) === pos;
        }),
      };

    case HOME_FETCH_STATISTICS_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchStatisticsPending: false,
        fetchStatisticsError: action.data.error,
      };

    case HOME_FETCH_STATISTICS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchStatisticsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/fetchStatistics.js